import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { OnlineAttendance } from 'pages/teacher/OnlineAttendance';
import { Sidebar } from 'components/shared/sidebar';
import BreadCrumb from 'components/shared/BreadCrumb';
import { loginUser } from 'recoil/loginUser';
import { useRecoilState, useRecoilValue } from 'recoil';
import Attendance from 'pages/Attendance';
import { useGetCommonApi } from 'hooks';
import { useGetRequiredApi } from 'hooks/useGetRequiredApi';
import { subjectOptionDataState } from 'recoil/subject/subjectOptionDataState';
import { teacherInfoState } from 'recoil/subject/teacherInfoState';

export const AttendanceLayout = () => {
  const user = useRecoilValue(loginUser);
  const subjectState = useRecoilValue(subjectOptionDataState);
  const [selectTeacherInfo, setSelectTeacherInfo] = useRecoilState(teacherInfoState);
  const [filteredAdvisorList, setFilteredAdvisorList] = useState([]);

  const { semestersData } = useGetCommonApi();
  const { teacherInfoSelectBoxQueryData } = useGetRequiredApi(null, subjectState.termId);
  const mainTeachers = teacherInfoSelectBoxQueryData?.flatMap(item => item.mainTeachers) || [];
  const advisorTeachers = teacherInfoSelectBoxQueryData?.flatMap(item => item.advisorTeachers) || [];

  const handleSelectMainTeacherBox = (e) => {
    setSelectTeacherInfo(prev => ({ ...prev, advisorNumber: null, advisorName: null }));
    const selectedTeacherNumber = e.target.value;
    if (!selectedTeacherNumber) { setFilteredAdvisorList([]); return; }
    const selectedProfessor = mainTeachers.find(item => item.teacherNumber === selectedTeacherNumber);
    if (!selectedProfessor) return;
    const filtered = advisorTeachers.filter(advisor =>
      advisor.courseTeacherInfo.some(course =>
        selectedProfessor.courseTeacherInfo.some(mainCourse => mainCourse.sisCourseId === course.sisCourseId)
      )
    );
    setFilteredAdvisorList(filtered);
  };

  const handleSelectAdvisorBox = (e) => {
    const selectedAdvisor = advisorTeachers.find(item => item.teacherNumber === e.target.value);
    if (!selectedAdvisor) return;
    setSelectTeacherInfo(prev => ({ ...prev, advisorNumber: selectedAdvisor.teacherNumber, advisorName: selectedAdvisor.teacherName }));
  };

  return (
    <>
      <Sidebar />
      <main
        id='main'
        className='main'
        style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 168px)', minHeight: 'unset' }}
      >
        <BreadCrumb home={'/'} sublink={'/attendance'} title={'출석 (Attendance)'} />
        <div className='card' style={{ flexGrow: '1', height: '100%' }}>
          {/* <Tab eventKey="attendanceTeacher" title="현장 출석부">
              <AttendanceTeacher />
            </Tab> */}
          {user.role === 'ADMIN' ? (
            <OnlineAttendance />
          ) : user.role === 'TEACHER' ? (
            <OnlineAttendance />
          ) : (
            <Attendance />
          )}
        </div>
      </main>
    </>
  );
};
